/*
 * Public API Surface of material
 */

export * from './lib/ui-material';
